export class CommonHelpers {
    static DownloadAssets(url) {
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', '');
        link.style.display = 'none';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    }
    static DownloadFileObjectAssets(fileName, file) {
        const link = document.createElement('a')
        link.download = fileName
        link.href = URL.createObjectURL(file)
        link.click()
    }
    static getFinancialYearList = (startYear = 2023) => {
        const currentDate = new Date();
        const currentYear = currentDate.getFullYear();
        const currentMonth = currentDate.getMonth() + 1; // 1-12

        // Financial year starts in April → completed FY ends in March.
        // If it's before April, the last completed FY ended previous year.
        // If it's after March, the current FY is still running (not completed yet).
        const lastCompletedFY = currentMonth < 4 ? currentYear - 1 : currentYear - 1;

        const financialYears = [];

        for (let year = startYear; year <= lastCompletedFY; year++) {
            financialYears.push({
                label: `${year}-${year + 1}`,
                value: { start: year, end: year + 1 },
            });
        }

        return financialYears;
    };
    static getLastCompletedFinancialYear = () => {
        const currentDate = new Date();
        const currentYear = currentDate.getFullYear();
        const currentMonth = currentDate.getMonth() + 1; // 1–12

        // Financial year runs April–March
        // If before April (Jan–Mar): last completed FY ended previous March
        // If after March (Apr–Dec): last completed FY ended this March (currentYear)
        const fyEndYear = currentMonth < 4 ? currentYear - 1 : currentYear;
        const fyStartYear = fyEndYear - 1;

        console.log({ start: fyStartYear, end: fyEndYear });
        return { start: fyStartYear, end: fyEndYear };
    };
}